<template>
    <div>
        <div class="input-inner" :class="classList">
            <div v-if="label" :class="getLabelClass">
                {{ $t(label) }}
            </div>
            <b-form-radio
                :name="name"
                :required="required"
                :inline="inline"
                :checked="value"
                :value="valueReturn"
                :state="state"
                @change="checked"
            />
        </div>
    </div>

</template>
<script>
import BFormRadio from 'bootstrap-vue/es/components/form-radio/form-radio'
import formMethods from '@/components/frontoffice/mixins/formMethods'

export default {
  mixins: [formMethods],

  components: {
    'b-form-radio': BFormRadio
  },
  props: {
    classList: {
      type: String
    },
    valueReturn: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: ''
    },
    plain: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    checked () {
      this.$emit('input', this.valueReturn)
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
